// Classifies the backend-v2 response of POST /screens/{approve|reject}/:campaignid/:token
// into the outcome shown on the public screen approval view.
//
// The view must never reveal whether (or by whom) the request was already
// answered, so every business response counts as success. Only internal
// failures and an expired publisher token are reported.

export const SCREEN_APPROVAL_OUTCOMES = {
    SUCCESS: 'success',
    EXPIRED: 'expired',
    ERROR: 'error',
};

// backend-v2 creativeApprovalRequests.service.js returns this message with
// numberError 2, the same code as "already resolved". Replace with
// numberError 3 once the backend distinguishes expiry.
const TOKEN_EXPIRED_MESSAGE = 'Publisher token expired';

export const getScreenApprovalOutcome = (status, body) => {
    if (status >= 500) return SCREEN_APPROVAL_OUTCOMES.ERROR;

    // backend-v2 catches internal exceptions in the service and still answers
    // 200 with the error spread into the body (including its stack).
    if (status >= 200 && status < 300 && body?.stack) {
        return SCREEN_APPROVAL_OUTCOMES.ERROR;
    }

    if (body?.message === TOKEN_EXPIRED_MESSAGE) {
        return SCREEN_APPROVAL_OUTCOMES.EXPIRED;
    }

    return SCREEN_APPROVAL_OUTCOMES.SUCCESS;
};
